const actionTypes = {
  GET_SERVICE_CONFIG: 'GET_SERVICE_CONFIG',
  GET_CHANGE_PASSWORD_CONFIG: 'GET_CHANGE_PASSWORD_CONFIG'
};
export default actionTypes;